import * as React from "react";
import {
  EmrHeart,
  EmrLiquid,
  EmrNursingChart,
  EmrRFilled,
  EmrRestricted,
} from "@medstonetech/slate-icons";
import { DietType } from "enums";
import { Icon } from "@chakra-ui/react";

type DietTypeIconProps = React.ComponentProps<typeof Icon>;

const DIET_TYPE_ICON: Record<
  DietType,
  (props?: DietTypeIconProps) => JSX.Element
> = {
  Regular: (props) => <Icon as={EmrRFilled} color="cyan" {...props} />,
  Clear_liquid: (props) => <Icon as={EmrLiquid} color="orange" {...props} />,
  NPO: (props) => <Icon as={EmrRestricted} color="orange" {...props} />,
  Healthy: (props) => <Icon as={EmrHeart} color="cyan" {...props} />,
  Diabetic: (props) => <Icon as={EmrNursingChart} color="orange" {...props} />,
};

export { DIET_TYPE_ICON };
